// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyD3NqlHA-fzNTksWu4hEYXR9oOhzENi1gU",
  authDomain: "newyorktour-33c8c.firebaseapp.com",
  projectId: "newyorktour-33c8c",
  // Confirm the correct value from your Firebase console:
  storageBucket: "newyorktour-33c8c.appspot.com",
  messagingSenderId: "325514346549",
  appId: "1:325514346549:web:b5036ed4338f3d2894317c",
  measurementId: "G-F39JEDX1M2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (optional)
const analytics = getAnalytics(app);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Storage
const storage = getStorage(app);

// Export the services for use in your app
export { app, analytics, db, storage };
